import type emailZh from '../zh/email';

const email: typeof emailZh = {
  load_failed: 'Failed to load email conversations',
  stats_load_failed: 'Could not load email stats',
  thread_load_failed: 'Failed to load email',
  copied: 'Copied {{address}}',
  platform_fallback: 'Platform email: {{address}}',
  synced: 'Synced {{count}} Wowbit creators with email',
  marked_read: 'Marked as read',
  mark_read_failed: 'Could not mark the conversation as read',
  talent_detail: 'View creator details',
  unread_count: 'Unread {{count}}',
  sent_count: 'Sent {{count}}',
  received_count: 'Received {{count}}',
  opened_count: 'Opened {{count}}',
  intent_talent: 'Interested creators',
  bounced: 'Bounced',
  title: 'Email',
  platform_email: 'Platform email',
  forward_hint: 'Replies are forwarded to {{address}}',
  domain_hint: 'Creator replies land in this inbox. The sending domain cannot be changed',
  sent_month: 'Sent this month',
  quota_hint: '/ {{limit}} · Delivery {{rate}}% · {{remain}} left',
  unread: 'Unread',
  unread_threads: '{{count}} creator conversations',
  pending: 'Awaiting reply',
  pending_hint: 'Creator replied, waiting on us · Interested creators {{count}}',
  pending_reply_hint: 'The creator replied and is waiting on you',
  pending_reply_failed: 'Could not load the unreplied email count',
  new_send: 'New email',
  sync_talents: 'Sync Wowbit creators with email',
  change_bind: 'Change bound email',
  bind_mine: 'Bind my email',
  copy_platform: 'Copy platform email',
  conversations: 'Creator email conversations',
  sent_received: 'Sent {{sent}} · Received {{received}}',
  no_match: 'No matching conversations',
  empty_conversations: 'No email conversations yet',
  reply_placeholder: 'Reply to {{name}}…',
  reply: 'Reply',
  reply_sent: 'Replied',
  reply_failed: 'Could not send the reply',
  mark_read: 'Mark as read',
  idle: 'Select a creator on the left to view the email thread',
  empty_thread: 'No emails yet',
  opened: 'Opened',
  filter_all: 'All',
  status_WAITING_CREATOR: 'Waiting on creator',
  status_NEED_REPLY: 'Needs reply',
  status_PROCESSED: 'Processed',
  status_HARD_BOUNCE: 'Hard bounce',
  conversation_total: '{{total}} conversations',
  shop_required: 'Select a store first',
  search_placeholder: 'Search creators / email',
  intent: 'Interested',
  replied: 'Replied',
  follow_up: 'To follow up',
  tpl_sample: 'New product sample collaboration',
  tpl_repurchase: 'Repeat collaboration invite',
  tpl_blank: 'Blank email',
  fill_subject: 'Enter the email subject and body',
  sent_skipped: 'Sent {{sent}}, skipped {{skipped}} (no email / bounced)',
  sent_ok: 'Sent {{sent}} emails',
  send_failed: 'Failed to send. Please try again later',
  recipients: 'Select recipients',
  selected_skip: '{{count}} creators selected. Creators without email or with bounced addresses are skipped',
  invalid_address: 'Enter a valid email address',
  bound: 'Bound {{address}}. Creator replies will be forwarded to this address',
  bind: 'Bind',
  bind_hint:
    'After binding, creator replies are forwarded to this address. Sending still uses the platform email so delivery and replies stay together.',
  blocked_bounced: 'This address bounced (unreachable). Update the creator email before sending',
  blocked_quota: 'Monthly email quota is used up ({{limit}})'
};

export default email;
